var Applier = require('./Applier');

/**
 * Общие методы InteractiveParameterElement и InteractiveParameter
 * @type {Object}
 * Не оформлены в прототипе, потому что нет нужды, чтобы был конструктор с данными методами.
 * В прототипы методы записываются из данного объекта
 */
var InteractiveParameterElementAndInteractiveParameterCommonMethods = {
    /**
     * Определение "applyTo..."-методов в прототипах
     * @callback applyToMethod
     * @param {string} method
     * @param {Array} [args]
     */

    /**
     * Метод вызывает метод с аргументами у элемента/параметра и связанных элементов/параметров
     * @param {string} method
     * @param {Array} [args]
     */
    applyToSelfAndRelated: function (method, args) {
        Applier.applyTo(this, method, args);
        Applier.applyToContextsArray(this.related, method, args);
    },
    /**
     * Метод вызывает метод с аргументами у связанных элементов/параметров
     * @param {string} method
     * @param {Array} [args]
     */
    applyToRelated: function (method, args) {
        Applier.applyToContextsArray(this.related, method, args);
    }
};

module.exports = InteractiveParameterElementAndInteractiveParameterCommonMethods;



// WEBPACK FOOTER //
// ./assets/javascript/interactive_parameters/module/InteractiveParameterElementAndInteractiveParameterCommonMethods.js